module.exports = __webpack_public_path__ + "img/horizontal_4_1_2.d6e85b22.png";